export const painPoints = [
  {
    emoji: '🧭',
    title: "You don't know where to start",
    problem:
      'A blank document can slow you down when you need to organize an incident narrative, daily activity report, site observation, or shift summary.',
    answer: 'The system gives you structured starting points that you can customize with your own verified information.',
  },
  {
    emoji: '🔤',
    title: 'You struggle to structure professional documentation',
    problem:
      'You know what happened, but organizing the details into a clear, chronological, professional report can take additional effort.',
    answer:
      'Use prompts that guide the AI to organize information, distinguish observations from assumptions, and produce drafts for your review.',
  },
  {
    emoji: '🧩',
    title: "Generic AI responses don't fit your work",
    problem:
      'A general AI instruction may overlook the context, format, or specific requirements of private security operations.',
    answer:
      'These prompts provide more structured instructions so you can guide the AI toward outputs that better fit your task.',
  },
  {
    emoji: '🎯',
    title: 'You want to spend less time rewriting routine material',
    problem:
      'Repeatedly drafting handover notes, client updates, checklists, and administrative messages can make an already demanding shift more complicated.',
    answer: 'Use reusable prompt structures to establish a more consistent starting point for recurring tasks.',
  },
];
